<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     生产管理--待派任务
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="mes-create header-padding">
    <f-page-header />

    <div class="filter-container">
      <div class="filter-box">
        <span class="filter-item">
          <f-radio-btn-group
            v-model="query.status"
            :groups="radios"
            type="arrow"
            @change="fetchData(1)"
          />
        </span>
        <span class="filter-item lg">
          <mes-num-selector v-model="query.mfgid" placeholder="选择制号" @change="fetchData(1)" />
        </span>
        <span class="filter-item sm">
          <pp-station-selector v-model="query.stationid" placeholder="选择工位" @change="fetchData(1)" />
        </span>
        <span class="filter-item sm">
          <f-search-input v-model="query.keyword" @change="fetchData(1)" />
        </span>
        <!-- <span class="filter-item sm">
          <search-input v-model="query.keyword" @change="fetchData(1)"/>
        </span> -->
      </div>

      <div class="toolbox">
        <el-button type="success" icon="el-icon-plus" @click="editMes()">新建工单</el-button>
        <el-button type="success" icon="el-icon-upload2" plain @click="importShow = true">导入</el-button>
      </div>
    </div>

    <div
      v-if="!list.length && !query.status && !query.stationid && !query.keyword && !query.mfgid && !loading"
      class="flex-center column"
      style="margin-top: 80px"
    >
      <div class="font-2x">电子派工流程</div>
      <div class="steps flex mt-mg">
        <div
          v-for="(item, i) in steps"
          :key="item.value"
          role="button"
          :style="i == steps.length - 1 ? 'padding-right: 45px' : 'padding-right: 60px'"
          :class="i == 0 ? 'pl-hg' : 'pl-hg'"
          class="item pl-hg"
        >
          <span class="font-lg">{{ item.title }}</span>
          <!-- 箭头样式 -->
          <div v-if="i !== steps.length - 1" class="arrow-container">
            <div class="arrow"></div>
          </div>
        </div>
      </div>
    </div>

    <el-card v-else v-loading="loading" class="table-card" style="z-index: 998;" shadow="never">
      <el-table
        ref="listTable"
        :data="list"
        style="width: 100%"
        size="medium"
        class="padding-small"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="60"></el-table-column>

        <el-table-column label="工单号" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="flex align-items-center">
              <el-link
                :underline="false"
                @click="toDetail(scope.row.workorderid)"
              >{{ scope.row.workorder_no }}</el-link>
              <el-tooltip content="主工单" placement="top" v-if="scope.row.type == 1" >
                <icon-svg icon-class="maintask" style="font-size: 22px"/>
              </el-tooltip>
              <el-tooltip content="子工单" placement="top" v-else-if="scope.row.type == 2">
                <icon-svg icon-class="subtask" style="font-size: 22px"/>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="部件编码/名称" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="text-muted">{{ scope.row.material_no}}</div>
            <div class>{{ scope.row.material_title}}</div>
          </template>
        </el-table-column>
        <el-table-column label="工序编码/名称" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="text-muted">{{ scope.row.process_no}}</div>
            <div class>{{ scope.row.process_title}}</div>
          </template>
        </el-table-column>
        <el-table-column label="派工数量" min-width="80" show-overflow-tooltip align="right">
          <template slot-scope="scope">
            <span class="font-16 number text-bold">{{ scope.row.plan_num }}</span>
            <span class="font-13 text-muted">件</span>
          </template>
        </el-table-column>
        <el-table-column label="额定工时" min-width="120" align="right">
          <template slot-scope="scope">
            <span class="font-16 number text-bold">{{ scope.row.standard_hour }}</span>
            <span class="font-13 text-muted">{{ scope.row.standard_unit }}/件</span>
          </template>
        </el-table-column>

        <el-table-column label="附加工时" min-width="100" align="right">
          <template slot-scope="scope">
            <span class="font-16 number text-bold">{{ scope.row.add_hour }}</span>
            <span class="font-13 text-muted">{{ scope.row.standard_unit }}</span>
          </template>
        </el-table-column>
        <el-table-column width="20" />
        <el-table-column label="工位" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link class="link-class" :underline="false" @click="toWorkstationDetail(scope.row)">
              <span>{{ scope.row.station_title }}</span>
            </el-link>
            <!-- <span>{{ scope.row.station_title }}</span> -->
          </template>
        </el-table-column>
        <el-table-column label="计划开始时间" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.plan_starttime | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="计划结束时间" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.plan_endtime | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="70" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.remark }}</span> -->
            <el-tooltip v-if="scope.row.remark" :content="scope.row.remark" placement="top">
              <i class="el-icon-chat-dot-round" style="font-size: 16px;"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="right" min-width="160">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status == 10" type="text" @click="issueOne(scope.row)">下发</el-button>
            <el-button type="text" @click="editMes(scope.row)">编辑</el-button>
            <el-popover
              placement="left-start"
              width="120"
              trigger="click"
              popper-class="tool-pop"
              :visible-arrow="false"
            >
              <div class="pop-item" role="button" @click="clone(scope.row)">克隆</div>
              <div class="pop-item" role="button" @click="deleteOne(scope.row)">删除</div>
              <i class="el-icon-more font-md ml mr-sm text-muted" slot="reference" role="button"></i>
            </el-popover>
          </template>
        </el-table-column>

        <template slot="empty">
          <img class="image huger mt-lg" src="@/assets/empty.png" />
          <div class="font-md mb-hg">暂无数据</div>
        </template>
      </el-table>
    </el-card>

    <f-table-footer
      checkbox
      :list="list"
      :selection="multiSelection"
      @toggle="toggleAll"
      :total="total"
      :pindex.sync="query.pindex"
      :psize.sync="query.psize"
      @change="fetchData"
    >
      <template slot="left">
        <el-button plain :disabled="issueDis" size="mini" @click="issueAll">下发</el-button>
        <el-button
          :class="{'ml-lg': query.status == 10}"
          plain
          :disabled="multiSelection.length === 0"
          size="mini"
          @click="deleteMulti"
        >删除</el-button>
        <el-button class="ml-lg" plain :disabled="total === 0" size="mini" @click="exportM">导出</el-button>
      </template>
    </f-table-footer>

    <new-workorder
      v-if="dialogShow"
      :show.sync="dialogShow"
      :workorderid="activeWorkorderid"
      @success="fetchData(1)"
    />
    <clone-workorder
      v-if="cloneShow"
      :show.sync="cloneShow"
      :workorderid="cloneWorkorderid"
      @success="fetchData(1)"
    />

    <mes-workorder-import v-if="importShow" :show.sync="importShow" @submit="fetchData(1)" />
  </div>
</template>

<script>
import {
  getMesWorkorderListApi,
  exportMesWorkorderApi,
  delMesWorkorderApi,
  sendMesWorkorderApi
} from "@/api/mes/workorderApi";

export default {
  name: "MesCreate",

  components: {
    MesWorkorderImport: () =>
      import("@/views/mes/components/MesWorkorderImport"),
    MesNumSelector: () => import("@/views/mes/components/MesNumSelector"),
    PpStationSelector: () => import("@/views/pp/components/PpStationSelector"),
    NewWorkorder: () => import("./components/NewWorkorder"),
    CloneWorkorder: () => import("./components/CloneWorkorder")
  },

  data() {
    return {
      dialogShow: false,
      importShow: false,
      activeWorkorderid: null,
      cloneWorkorderid: null,
      query: {
        keyword: "",
        status: 0,
        stationid: null,
        mfgid: null,
        pindex: 1,
        psize: this.$store.state.commonStore.psize
      },
      total: 0,
      multiSelection: [],
      radios: [
        { value: 0, title: "全部任务", separate: true },
        { value: 1, title: "待排产" },
        { value: 2, title: "待下发" }
      ],
      steps: this.$store.state.mesStore.dispatchProcessArr,
      list: [],
      loading: false,
      cloneShow: false,

      query2: {
        keyword: "",
        pindex: 1,
        psize: this.$store.state.commonStore.psize
      },
      list2: [],
      total2: 0,
      loading2: false
    };
  },

  computed: {
    issueDis() {
      const temp = this.multiSelection.filter(i => i.status == 10);
      return temp.length > 0 && temp.length === this.multiSelection.length
        ? false
        : true;
    }
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData(page, loading = true) {
      if (page) this.query.pindex = page;
      if (loading) this.loading = true;
      getMesWorkorderListApi(this.query).then(res => {
        this.loading = false;
        if (!res.errno) {
          this.list = res.data.list;
          this.total = res.data.total;
        }
      });
    },

    fetchWorkstationData(page, loading = true) {
      if (page) this.query2.pindex = page;
      if (loading) this.loading2 = true;
      getStationListApi(this.query2).then(res => {
        this.loading2 = false;
        if (!res.errno) {
          this.list2 = res.data.list;
          this.list2.forEach(item => {
            item.binder = item.operators.concat(item.inspectors);
          });
          this.total2 = res.data.total;
        }
      });
    },

    handleSelectionChange(val) {
      this.multiSelection = val;
    },

    toggleAll() {
      this.$refs.listTable.toggleAllSelection();
    },

    editMes(row) {
      this.activeWorkorderid = row ? row.workorderid : null;
      this.dialogShow = true;
    },

    deleteOne(item) {
      document.body.click();
      this.$confirm(
        `即将删除工单<span class="text-primary"> ${
          item.workorder_no
        }</span>，是否继续 ？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.loading = true;
          delMesWorkorderApi({ workorderids: [item.workorderid] }).then(res => {
            this.loading = false;
            if (!res.errno) {
              this.$message.success("工单删除成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },
    clone(row) {
      this.cloneWorkorderid = row ? row.workorderid : null;
      document.body.click();
      this.cloneShow = true;
    },

    toWorkstationDetail(row) {
      const { stationid } = row;
      const _this = this;
      this.$sdetail({
        stationid,
        handleChange: () => {
          _this.fetchWorkstationData();
        }
      });
    },

    deleteMulti() {
      let tmp = this.multiSelection.map(v => v.workorderid);
      this.$confirm(
        `即将删除<span class="text-primary"> ${
          tmp.length
        }</span> 个工单，是否继续 ？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.loading = true;
          delMesWorkorderApi({ workorderids: tmp }).then(res => {
            this.loading = false;
            if (!res.errno) {
              this.$message.success("工单删除成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    issueOne(row) {
      sendMesWorkorderApi({ workorderids: [row.workorderid] }).then(res => {
        if (!res.errno) {
          this.$message.success("工单下发成功！");
          this.fetchData();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    issueAll() {
      let tmp = this.multiSelection.map(v => v.workorderid);
      this.$confirm(
        `即将下发<span class="text-primary"> ${
          tmp.length
        }</span> 条工单，是否继续 ？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.loading = true;
          sendMesWorkorderApi({ workorderids: tmp }).then(res => {
            this.loading = false;
            if (!res.errno) {
              this.$message.success("工单下发成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    exportM() {
      exportMesWorkorderApi(this.query).then(res => {
        if (!res.errno) {
          window.open(res.data.url);
          this.$message.success("工单导出成功！");
        }
      });
    },

    toDetail(id) {
      this.$detail(id);
    }
  }
};
</script>

<style lang="scss" scoped>
.mes-create {
  position: relative;
  .steps {
    height: 148px;
    border-radius: 3px;
    overflow: hidden;
    .item {
      height: 100%;
      line-height: 148px;
      position: relative;
      background-color: #fff;
      &:hover {
        color: #07c160;
      }
      .arrow-container {
        position: absolute;
        top: 0;
        right: 0px;
        height: 148px;
        width: 40px;
        overflow: hidden;
        .arrow {
          transform: rotate(45deg) skew(20deg, 20deg);
          background-color: #fff;
          content: "";
          border: 6px solid #eeeff4;
          border-bottom: none;
          border-left: none;
          background-color: #fff;
          height: 85px;
          width: 85px;
          position: absolute;
          display: block;
          top: 32px;
          left: -40px;
          z-index: 10;
        }
      }
    }
    &::after {
      content: ".";
      display: block;
      clear: both;
      visibility: hidden;
      font-size: 0;
      height: 0;
      line-height: 0;
    }
  }

  .link-class {
    width: 100%;
    /deep/.el-link--inner {
      width: 100%;
    }
  }
}
</style>
